import React from "react";
import { Button } from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import AxiosClient from "../../../_helpers/http.helper";
import config from "../../../config";
import { formatUrl } from "../../../_helpers/url.format.helper";
import { Link } from "react-router-dom";
import _ from "lodash";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";

export class UpdateEnvironment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isConfirmationModalOpen: false,
            isHideConfirmationModalOpen:false,
            isBatchIdModalOpen: false,
            isHideBatchIdModalOpen: false,

            batchId: null
        };
    }

    buildPayload = () => {
        const { selected, items } = this.props;
        const curatedIds = _.keys(selected);
        let collectionIds = [];
        curatedIds.map(curatedId => {
            let curatedCollection = _.find(items, function(item) {
                return item.curatedCollectionId === curatedId;
            });
            collectionIds.push(curatedCollection.parentCollection.collectionId);
        });

        return collectionIds;
    };

    pushToLive = () => {
        const url = formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.pushToLive
        );
        const body = this.buildPayload();
        AxiosClient.post(url, body).then(result => {
            this.setState({
                isBatchIdModalOpen: true,
                batchId: result.data
            });
        });
    };

    pushToHide = () => {
        const url = formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.pushToHide
        );
        const body = this.buildPayload();
        AxiosClient.post(url, body).then(result => {
            this.setState({
                isHideBatchIdModalOpen: true,
                batchId: result.data
            });
        });
    };

    render() {
        return (
            <div>
                <h1>Push Live</h1>
                <div className="container-env">
                    <div className="container-text">
                        <div>Push selected curated collections ?</div>
                    </div>
                    <Button
                        btnType="primary"
                        onClick={() => this.setState({ isConfirmationModalOpen: true })}
                    >
                        Update
                    </Button>
                </div>

                <ModalDialog
                    title="Push Live"
                    showModal={this.state.isConfirmationModalOpen}
                    onSuccess={() => {
                        this.setState({ isConfirmationModalOpen: false });
                        this.pushToLive();
                    }}
                    showCancel={true}
                    onCancel={() => {
                        this.setState({ isConfirmationModalOpen: false });
                    }}
                    successText="OK"
                >
                    Are you sure you want to make the selected curated collections live?
                </ModalDialog>

                <ModalDialog
                    title="Batch ID Information"
                    showModal={this.state.isBatchIdModalOpen}
                    showCloseControls={false}
                    onSuccess={() => {
                        this.setState({ isBatchIdModalOpen: false });
                        this.props.refreshSearch();
                    }}
                    successText="OK"
                    showCancel={false}
                >
                    {TEXT_TYPES.UPLOAD_BATCH_INFO_MSG} {this.state.batchId}.{" "}
                    <Link to="/cc-migration-status">
                        <b>{TEXT_TYPES.VIEW_STATUS_MSG}</b>
                    </Link>
                </ModalDialog>
                <span>
                    <div style={{"paddingTop":'10px'}}>
                        <h1>Push Hide </h1>
                        <div className="container-env">
                            <div className="container-text_hide">
                                <div>Push selected curated collections ?</div>
                            </div>
                            <Button
                                btnType="primary"
                                onClick={() => this.setState({ isHideConfirmationModalOpen: true })}
                            >
                        Hide
                            </Button>
                        </div>
                        <ModalDialog
                            title="Push Hide"
                            showModal={this.state.isHideConfirmationModalOpen}
                            onSuccess={() => {
                                this.setState({ isHideConfirmationModalOpen: false });
                                this.pushToHide();
                            }}
                            showCancel={true}
                            onCancel={() => {
                                this.setState({ isHideConfirmationModalOpen: false });
                            }}
                            successText="OK"
                        >
                             Are you sure you want to make the selected curated collections hide?
                        </ModalDialog>

                        <ModalDialog
                            title="Batch ID Information"
                            showModal={this.state.isHideBatchIdModalOpen}
                            showCloseControls={false}
                            onSuccess={() => {
                                this.setState({ isHideBatchIdModalOpen: false });
                                this.props.refreshSearch();
                            }}
                            successText="OK"
                            showCancel={false}
                        >
                            {TEXT_TYPES.UPLOAD_BATCH_INFO_MSG} {this.state.batchId}.{" "}
                            <Link to="/cc-migration-status">
                                <b>{TEXT_TYPES.VIEW_STATUS_MSG}</b>
                            </Link>
                        </ModalDialog>
                    </div>
                </span>
            </div>
            
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/CuratedSearch/UpdateEnvironment.js